module.exports = __webpack_public_path__ + "img/0Q3B7249_BlackMatted_MockedUp.db878636.jpg";